export default __webpack_public_path__ + "static/media/livingfirestorm.54af72a2.png";